import { Toggle } from "pepsico-ds";
import { useRef, useState } from "react";
import "./toggleStyles.scss";

export default function SwitchField(props) {
  const { value, updateValue, label, schema, uiSchema, disabled } = props;
  const infoIconRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => setShowTooltip(true);
  const handleMouseLeave = () => setShowTooltip(false);

  return (
    <div className="switch-field-component">
      {uiSchema?.labelTooltip ? (
        <div className="toggle-with-tooltip">
          <div className="custom-label">
            <span>{label}</span>
            <span
              className="info-icon"
              ref={infoIconRef}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              ⓘ
            </span>
            {showTooltip && uiSchema?.labelTooltip && (
              <div className="custom-tooltip">{uiSchema.labelTooltip}</div>
            )}
          </div>
          <Toggle
            className="toggleStyles"
            label=""
            onUpdate={updateValue}
            size={uiSchema.size || "medium"}
            checked={value ?? schema.default}
            value={uiSchema?.rightLabelComponent ?? ""}
            disabled={disabled || uiSchema.readOnly}
          />
        </div>
      ) : (
        <Toggle
          className="toggleStyles"
          label={uiSchema?.rightLabelComponent ? "" : label}
          onUpdate={updateValue}
          size={uiSchema.size || "medium"}
          checked={value ?? schema.default}
          value={uiSchema?.rightLabelComponent ?? ""}
          disabled={disabled || uiSchema.readOnly}
        />
      )}
    </div>
  );
}
